import { render, staticRenderFns } from "./ShDelButton.md?vue&type=template&id=75654f76"
import script from "./ShDelButton.md?vue&type=script&lang=js"
export * from "./ShDelButton.md?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports